// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1591264197908
      var cssReload = require("/home/rooney/pageProofs/bytecode/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  